<template>
  <div class="common-panel-view">
    <div class="doc-area">
      <md-icon @click.native="$emit('open-menu')">
        menu
        <md-tooltip>Меню</md-tooltip>
      </md-icon>
      <span
        class="name-content"
        @click="$emit('rename')"
      >
        <template v-if="docName !== null">
          {{ docName }}
        </template>
        <template v-else>
          Несохраненный документ
        </template>
      </span>
    </div>
    <div class="auth-area">
      <div
        v-if="isAuthorized"
        class="login"
      >
        <span
          class="login-content"
        >{{ profileName }}</span>
        <a
          class="link logout"
          @click="$emit('logout')"
        >Выйти</a>
      </div>
      <a
        class="link login"
        v-else
        @click="$emit('login')"
      >Войти</a>
      <!--
      <a
        class="link"
        href="https://art-jump.reformal.ru/proj/"
      >Отзывы и предложения</a>
      -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    docName: String,
    login: String,
    isAuthorized: Boolean,
    profileName: String
  }
}
</script>

<style lang="sass">
.common-panel-view
  text-align: left
  padding: 8px 0px 3px 45px
  font-size: 1em
  height: 35px
  .doc-area
    .name-content
      cursor: pointer
  .link
    cursor: pointer
  .logout
    font-size: 0.8em
  .auth-area
    position: absolute
    right: 10px
    top: 5px
    text-align-right
</style>


// WEBPACK FOOTER //
// CommonPanelView.vue?e555718e